import styled from 'styled-components';
import { getModalSize, getAnimationFrom } from './animations';
export const Overlay = styled.div `
  ${({ animation, transitionSpeed }) => getAnimationFrom(animation, 'FadeIn FadeOut', transitionSpeed)}
  background-color: rgba(0, 0, 0, 0.5);
  overflow: auto;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 1000;
`;
export const ModalContentContainer = styled.div `
  ${({ transitionType, animation, transitionSpeed }) => getAnimationFrom(animation, transitionType, transitionSpeed)}
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 25px;
  position: absolute;
  min-height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
`;
export const ModalContent = styled.div `
  position: relative;
  max-width: 100%;
  ${({ modalSize }) => getModalSize(modalSize)}
`;
export const CloseButton = styled.button `
  appearance: none;
  background-color: #ffffff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: absolute;
  text-align: center;
  top: -25px;
  right: -25px;
  height: 50px;
  width: 50px;
  z-index: 1;
  svg {
    vertical-align: middle;
  }
  &:hover {
    background-color: #002971;
    svg path {
      fill: #ffffff;
    }
  }
`;
export const ModalTrigger = styled('span') `
  cursor: pointer;
`;
//# sourceMappingURL=styled.js.map